

















































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwBarProgress } from '@libs-uuif/shared/sw-progress';
import { MswWidgetCard } from '@/shared/custom-component/msw-widget-card';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import  { MswApiService } from '@/shared/msw-api-service';
import { envCongif } from '@/shared/env.config';
const cssPrefix = 'msw-downloads-widget';

@Component({
  components: {
    MswWidgetCard,
    SwBarProgress,
    SwIcon,
  },
})
export default class MswDownloadsWidget extends SwExtendedVue {
  cssPrefix =  cssPrefix;
  downloadStatus = false;
  waitForResp = false;
  downloadTitle = this.$t('workflow.dashboard.downloadsAvailable')
  .toString();
  downloadWidgetList = [{
    downloadGroupName : '',
    deploymentType : '',
  },
  {
    downloadGroupName : '',
    deploymentType : '',
  }];

  routeToDownloads() {
    // Redirecting to downloadCenter page
    if (window.location !== window.top.location) {
      window.top.location.href = (`${envCongif.msw_url}/muir/ui/downloadcenter`);
    } else {
      this.$router.push({ path: '/m/feature/downloadcenter' });
    }
  }
  created() {
    this.waitForResp = true;
    MswApiService.widgetsInfo.getDownloadsAvailable()
      .then((resp:any) => {
        this.waitForResp = false;
        if (resp['content'] === {}) {
          this.downloadStatus = false;
        } else {
          this.downloadStatus = true;
          const tempDownloadData = resp['content']['downloadWidgetList'];
          tempDownloadData.forEach((val:any , index : number) => {
            if (index < 2) {
              this.downloadWidgetList[index]['deploymentType'] = val['deploymentType'];
              this.downloadWidgetList[index]['downloadGroupName'] = val['downloadGroupName'];
            }
          });
        }
      })
      .catch(() => {
        this.waitForResp = false;
      });
  }
}
